import React from 'react';
import { Link } from 'react-router-dom';
import { BrandLogo } from './BrandLogo';

const FOOTER_LINKS: Array<{ to: string; label: string }> = [
  { to: '/catalog', label: 'Pricing & Catalog' },
  { to: '/privacy-policy', label: 'Privacy Policy' },
  { to: '/terms', label: 'Terms of Service' },
  { to: '/acceptable-use-policy', label: 'Acceptable Use' },
  { to: '/cookies-policy', label: 'Cookies Policy' },
  { to: '/cancellation-refund-policy', label: 'Refund Policy' },
  { to: '/shipping-delivery-policy', label: 'Shipping & Delivery' },
  { to: '/contact-us', label: 'Contact Us' },
  { to: '/company', label: 'About Us' },
];

export function Footer() {
  return (
    <footer className="bg-surface-lowest border-t border-outline-variant/30 py-16">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-8">
        <div>
          <BrandLogo variant="icon" size="lg" href="/" />
          <p className="text-sm text-on-surface-variant mt-2">© 2026 InviteCloud. Crafted for celebration.</p>
        </div>
        <div className="flex flex-wrap gap-6 sm:gap-8 justify-center">
          {FOOTER_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="text-sm text-on-surface-variant hover:text-primary underline-offset-4 hover:underline transition-all"
            >
              {link.label}
            </Link>
          ))}
        </div>
      </div>
    </footer>
  );
}
